import ComingSoon from "../../../components/ui/ComingSoon/ComingSoon";
import PageHeader from "../../pageheader/components/PageHeader"

const AssistantPage: React.FC = () => {
    return (
        <>
            <PageHeader name="AI Assistant"></PageHeader>
            <ComingSoon />
        </>
    )
}

export default AssistantPage;